import React from "react";

const DigitalMarketingHeading = () => {
  return (
    <div className="pt-64 md:pt-40 px-8 md:px-8 font-poppins">
      <div className="flex flex-col md:flex-row items-center justify-center mb-10">
        <div className="text-left md:w-1/2  space-y-2 md:ml-auto">
          <h1 className=" text-4xl md:text-6xl font-bold font-poppins mb-2 md:mb-4 ">
            <div>AI-Based Business Solutions Provider at Hyderabad </div>

          </h1>
          <p className="text-4xl font- text-[#0D283F] mt-2 md:mt-6">
            Elevate Your Brand’s Online Presence
          </p>
        </div>

        <div className="md:w-1/3 mt-6 md:mt-0 flex justify-start">
          <img
            src="/ourservice.png"
            alt="Digital Marketing Illustration"
            className="w-60 md:w-[456px] animate-float"
          />

        </div>
      </div>
    </div>
  );
};

export default DigitalMarketingHeading;
